import React from 'react';
import { Switch, Route } from 'react-router-dom';
import PublicRoute from './helpers/publicRoute';

// pages
import Login from './pages/Login';
import SignUp from './pages/Signup';
import ForgotPassword from './pages/forgotpassword';
import EmailVerification from './pages/emailverification';
import NewPasswordPage from './pages/newpassowrd';
import BusinessAssociate from './pages/business-associate';
import Dashboard from './pages/dashboard';
import PageTemplate from './components/templates/PageTemplate';
import Stores from './pages/stores';
import StoreGroups from './pages/store-groups';
import Promotions from './pages/promotions';
import StoreManagers from './pages/store-managers';
import Statements from './pages/statements';
import PaymentHistory from './pages/payment-history';

const FakePrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      <PageTemplate showTemplate>
        <Component {...props} />
      </PageTemplate>
    )}
  />
);
function Router() {
  // const { isLoggedIn, status } = useContext(AuthContext);
  const isLoggedIn = false;

  return (
    <Switch>
      {/* <PrivateRoute path="/business/:view" component={Pages} status={status} isLoggedIn={isLoggedIn} /> */}
      {/* <PublicRoute path="/development" component={Development} /> */}
      <FakePrivateRoute path="/dashboard" component={Dashboard} />
      <FakePrivateRoute path="/stores" component={Stores} />
      <FakePrivateRoute path="/store-groups" component={StoreGroups} />
      <FakePrivateRoute path="/promotions" component={Promotions} />
      <FakePrivateRoute path="/store-managers" component={StoreManagers} />
      <FakePrivateRoute path="/statements" component={Statements} />
      <FakePrivateRoute path="/payment-history" component={PaymentHistory} />
      <PublicRoute restricted path="/set-password" component={NewPasswordPage} isLoggedIn={isLoggedIn} />
      <PublicRoute restricted path="/forgot-password" component={ForgotPassword} isLoggedIn={isLoggedIn} />
      <PublicRoute restricted path="/email-verification" component={EmailVerification} isLoggedIn={isLoggedIn} />
      <PublicRoute restricted path="/sign-up" component={SignUp} isLoggedIn={isLoggedIn} />
      <PublicRoute path="/business-associate" component={BusinessAssociate} isLoggedIn={isLoggedIn} />
      <PublicRoute restricted path="*" component={Login} isLoggedIn={isLoggedIn} redirectTo="/dashboard" />
    </Switch>
  );
}

export default Router;
